import { api } from "lib/graphql/api"
import { hasDemand } from "lib/authorization/has-demand"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getRelatedTreeCount = api(async function getRelatedTrees(id, includeTailored) {
    if (!hasDemand("manageRegime")) return 0
    return !id
        ? 0
        : query(
              gql`
                  query GetRelatedTreesCount($id: String!, $includeTailored: Boolean) {
                      getRelatedTrees(id: $id, take: 0, includeTailored: $includeTailored) {
                          count
                      }
                  }
              `,
              { id, includeTailored },
              { returns: "getRelatedTrees.count" }
          )
})
